<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Estado</span>
          <v-select
            :options="estados"
            name="Estado"
            id="Estado"
            v-model="estado"
            v-validate="{ required: true }"
            @selected="buscaDadosSelectsCidades"
            :state="validateState('Estado')"
            :class="validateClass('Estado')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Cidade</span>
          <v-select
            :options="cidades"
            name="Cidade"
            id="Cidade"
            v-model="formCadastro.cidade"
            :state="validateState('Cidade')"
            :class="validateClass('Cidade')"
          ></v-select>
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idTabelaEstadoCidade == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import swal from 'sweetalert';
import vSelect from 'vue-select';
import cpfCnpj from '../../services/cpfCnpj';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados(value) {
      this.preencheForm();
    },
    estado(value) {
      this.formCadastro.estado = value;
      this.formCadastro.cidade = null;
      this.buscaDadosSelectsCidades(
        'domMunicipio',
        'cidades',
        'nomeCidade',
        'idCidade',
      );
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      estados: [],
      cidades: [],
      grupos: [],
      languages: lang,
      estado: null,
      funcoesValicao: null,
      formCadastro: {
        idTabelaEstadoCidade: null,
        idTabela: this.$route.params.id,
        cidade: '',
        estado: '',
      },
    };
  },
  methods: {
    preencheForm() {
      if (this.dados.idTabelaEstadoCidade) {
        this.formCadastro.idTabelaEstadoCidade =
          this.dados.idTabelaEstadoCidade;
        this.formCadastro.idTabela = this.dados.idTabela;
        if (this.dados.cidade) this.formCadastro.cidade = this.dados.cidade;
        if (this.dados.estado) this.formCadastro.estado = this.dados.estado;
        if (this.estados.length > 0) {
          this.estado = this.estados.find((x) => x.label == this.dados.estado);
          /*if (this.formCadastro.estado == element[campoDescricao]) {
            this.formCadastro.estado = {
              id: element[campoPK],
              label: element[campoDescricao]
            };
          }*/
        }
      } else {
        this.formCadastro.idTabela = this.dados.idTabela;
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;

      var action = 'Atualizar';
      var msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.idTabelaEstadoCidade) {
        action = 'Adicionar';
        msgRetorno = 'Registro Adicionado com sucesso';
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post('TabelaEstadosCidades', action, this.formCadastro)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      this.$vs.loading();
      this[array] = [];
      service
        .getAll('g', {}, `${model}/list/codUf/${this.formCadastro.estado.id}`)
        .then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });
          if (this.formCadastro.cidade != '') {
            this.formCadastro.cidade = this[array].find(
              (x) => x.label == this.dados.cidade,
            );
          }

          this.$vs.loading.close();
        });
    },
    resetForm() {
      this.formCadastro = {
        idTabelaEstadoCidade: null,
        cidade: '',
        estado: '',
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
  },
  mounted() {
    this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize('ptBr', locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
